import {i18nStrict} from '~ui/utils/i18n';

import en from './en.json';
import ru from './ru.json';

export const i18n = i18nStrict({en, ru});
